import { gql } from 'apollo-boost';

export const TAGS_QUERY = gql`
    query tags{
        tags{
            edges{          
                node{
                    id
                    name
                    slug
                    metadata
                    createdAt
                    updatedAt
                }
            }
        }
    }
`;
